
const dafaultState = {
	fileForTS: null,
	fileForTSName: "",
	fileWithTSForDownload: null,
	fileInput: null,
	fileInputName: "",
	fileWithTS: null,
	fileWithTSName: ""
}

export default function (state=dafaultState, { type, payload }) {
	switch(type) {
		case "SET_FILE_FOR_TS": {
			return {
				...state,
				fileForTS: payload,
				fileForTSName: payload.name
			}
		}

		case "CLEAR_FILE_FOR_TS": {
			return {
				...state,
				fileForTS: null,
				fileForTSName: ""
			}
		}

		case "SET_FILE_WITH_TS_FOR_DOWNLOAD": {
			return {
				...state,
				fileWithTSForDownload: payload
			}
		}

		case "CLEAR_FILE_WITH_TS_FOR_DOWNLOAD": {
			return {
				...state,
				fileWithTSForDownload: null
			}
		}

		case "SET_FILE_INPUT": {
			return {
			    ...state,
				fileInput: payload,
				fileInputName: payload.name,
			}
		}

		case "CLEAR_FILE_INPUT": {
			return {
			    ...state,
				fileInput: null,
				fileInputName: ""
			}
		}

		case "SET_FILE_WITH_TS": {
			return {
			    ...state,
				fileWithTS: payload,
				fileWithTSName: payload.name
			}
		}

		case "CLEAR_FILE_WITH_TS": {
			return {
			    ...state,
				fileWithTS: null,
				fileWithTSName: ""
			}
		}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/createVerifyTSReducer.js